<template>
    <div
        id="site-wrapper"
        class="text-slate-800 text-lg"
        :class="{ 'is-home': isHome }"
    >
        <Header v-if="!isHome" />

        <main>
            <NuxtPage />
        </main>

        <Footer />
    </div>
</template>

<script setup lang="ts">
const route = useRoute()
const isHome = computed(() => route.path === '/')
</script>
